<template>
  <div class="">
    <Menu as="div" class="relative inline-block text-left">
      <div>

        <MenuButton
          class="inline-flex w-full items-center gap-2 justify-between rounded-md md:bg-black/20 p-2 text-sm font-medium text-[#C3C3C3] md:text-white md:hover:bg-black/30 md:focus:outline-none md:focus-visible:ring-2 md:focus-visible:ring-white/75">
          <Icon icon="solar:eye-broken" class="block md:hidden" />
          <p class="text-xs">

            {{ trans('lang.labels.colm_visible') }}
          </p>
          <ChevronDownIcon class="  hidden md:block -mr-1 ml-2 h-5 w-5 text-violet-200 hover:text-violet-100"
            aria-hidden="true" />
          <Icon class="block md:hidden" icon="ri:arrow-right-s-line" width="12" height="12" />
        </MenuButton>
      </div>

      <transition enter-active-class="transition duration-100 ease-out" enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
        <MenuItems
          class="absolute hrmColumnSelector right-0 mt-2 w-56 origin-top-right md:divide-y md:divide-gray-100 rounded-md  bg-[#383A3D] md:bg-white shadow-lg md:ring-1 ring-black/5 focus:outline-none hrmColumnSelector">
          <div class="md:px-1 md:py-1">
            <label
              class="cursor-pointer hover:bg-hrmThemeBgColor hover:text-hrmThemeTextColor text-gray-900 
            group flex w-full items-center rounded-md px-2 py-2 text-sm  text-white md:text-gray-900 bg-[#47494C] md:bg-white">
              <input class="hidden" type="checkbox" v-model="isSelectAll" @change="selectAll" />
              Select All Columns
            </label>
            <div class="overflow-y-auto max-h-44">
              <template v-for="(column, key) in columns" :key="key">
                <label :for="key" class="cursor-pointer hover:bg-hrmThemeBgColor hover:text-hrmThemeTextColor text-white md:text-gray-900 
                  group flex w-full items-center justify-between rounded-md px-2 py-2 text-sm">
                  <input class="hidden" :id="key" type="checkbox" :value="key" v-model="selections"
                    @change="selectOptions" />
                  {{ column.name }}
                  <template v-if="selections && selections.includes(key)">
                    <Icon icon="entypo:check" width="1.2em" height="1.2em" />
                  </template>
                </label>
              </template>
            </div>

          </div>

          <div class=" md:p-1">
            <label @click="resetDefault" class="cursor-pointer bg-hrmThemeBgColor text-hrmThemeTextColor
            group flex w-full items-center rounded-md px-2 py-2 text-sm">
              Reset default
            </label>
          </div>
        </MenuItems>
      </transition>
    </Menu>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import { Icon } from '@iconify/vue';

const props = defineProps(['columns', 'selectedColumns']);
const emits = defineEmits(['setValues']);

const selections = ref([]);
const isSelectAll = ref(false);

const selectAll = () => {
  if (isSelectAll.value) {
    selections.value = Object.keys(props.columns);
    emits('setValues', selections.value);
  }
}

const selectOptions = () => {
  emits('setValues', selections.value);
  isSelectAll.value = false;
}

const resetDefault = () => {
  const defaultCol = true;
  selections.value = Object.keys(
    props.columns
  ).filter(
    (key) => props.columns[key].main === defaultCol
  );
  emits('setValues', selections.value);
  isSelectAll.value = false;
}

onMounted(() => {
  selections.value = props.selectedColumns
})
</script>
<style>
.hrmColumnSelector {
  z-index: 32;
}
</style>